import React, { useState } from 'react';
import { Form, Button, Dropdown, Message } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css'; // Import Semantic UI CSS
import './ContactUs.css'; // Import custom CSS
import emailjs from 'emailjs-com';
import { Helmet } from 'react-helmet-async'

const ContactUs = () => {
  // State for form input values
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    // Simple validation
    if (!name || !email || !subject || !message) {
      setError('All fields are required.');
      return;
    }

    setError('');

    const templateParams = {
      user_name: name,
      user_email: email,
      user_subject: subject,
      message,
    };

    emailjs
      .send(
        'service_osob3kr', 
        'template_xr37o8z', 
        templateParams, 
        'cuV-XtB43ll9nU-w-'
      )
      .then(
        (response) => {
          console.log('Email sent successfully!', response.status, response.text);
          setSuccess('Your message has been sent successfully!');
          setName('');
          setEmail('');
          setSubject('');
          setMessage('');
        },
        (error) => {
          console.error('Failed to send email:', error);
          setError('An error occurred while sending your message. Please try again later.');
        }
      );
  };

  // Dropdown options for the subject
  const subjectOptions = [
    {/* key: 'job', text: 'Apply for a Job', value: 'Apply for a Job' */},
    { key: 'business', text: 'New Business', value: 'New Business' },
    { key: 'other', text: 'Other', value: 'Other' },
  ];

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact Us | Delta Property Management Group</title>
        <meta name="description" content="Reach out to Delta Property Managment Group (Delta PMG),
        if you have any questions do not be afraid to ask!"/>
        <link rel="canonical" href="https://www.deltapmg.com/contact-us" />

        <meta property="og:title" content="Contact Us | Delta Property Management Group" />
        <meta property="og:description" content="Reach out to Delta Property Managment Group (Delta PMG), if you have any questions do not be afraid to ask!" />
        <meta property="og:url" content="https://www.deltapmg.com/contact-us" />
        <meta property="og:type" content="website" />
      </Helmet>                   
      <div className="contact-container">
      {error && <Message negative>{error}</Message>}
      {success && <Message positive>{success}</Message>}
        <h1>Contact Us</h1>
        <Form onSubmit={handleSubmit} className="contact-form">
        <Form.Field className="form-field">
          <label className="label">Name</label>
          <input
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            />
        </Form.Field>
          <Form.Field type="email" className="form-field">
          <label className="label">Email</label>
          <input
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            />
        </Form.Field>
          <Form.Field className="form-field">
            <label className="label">Subject</label>
            <Dropdown type="subject" 
              control={Dropdown}
              selection
              options={subjectOptions}
              value={subject}
              placeholder="Select Subject"
              onChange={(e, { value }) => setSubject(value)}>
            </Dropdown>
        </Form.Field>
          <Form.Field type="message" className="form-field">
          <label className="label">Message</label>
          <textarea
            placeholder="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            control="textarea"
            className="form-input"
            />
        </Form.Field>
          <Button type="submit" primary className="submit-button">Send Message</Button>
        </Form>
      </div>
    </div>
  );
};

export default ContactUs;